import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useState, useMemo } from 'react';
import styled from 'styled-components';
import { M as Modal } from '../Modal/Modal-f212fbfb.js';
import { u as useIntl } from '../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-8b5154d9-98867d9c.js';
import { u as useTaktId } from '../TaktIdContext/TaktIdContext-f853b17a.js';
import { t as times } from '../LocalModules/storm-ui-icons/dist/esm/localIcons-889a4ef1-7553986d.js';
import { T as Text } from '../Text/Text-f48a0c0d.js';
import { I as Icon } from '../Icon/Icon-1e11d9f1.js';
import { k as keys } from '../LocalModules/storm-ui-utils/dist/esm/keyboardKeynames-04a50e15-b033061a.js';

const Pill = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-0"
})(["display:flex;justify-content:space-between;align-items:center;gap:", ";border:1px solid ", ";border-radius:", ";background:none;padding:5px 5px 5px 8px;font-size:", ";height:40px;:hover{border-color:", ";}"], ({
  theme
}) => theme.spacing.small, ({
  theme
}) => theme.palette.gray[150], ({
  theme
}) => theme.spacing.micro, ({
  theme
}) => theme.button.normal.fontSize, ({
  theme
}) => theme.palette.gray[25]);
const TextWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-1"
})(["display:flex;flex-direction:column;"]);
const FileText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-2"
})(["max-width:100px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;"]);
const LargeImage = /*#__PURE__*/styled('img').withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-3"
})(["max-width:100%;height:auto;"]);
const Thumbnail = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-4"
})(["display:flex;"]);
const SmallImage = /*#__PURE__*/styled('img').withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-5"
})(["white-space:nowrap;border-radius:5px;height:40px;width:auto;max-width:100px;cursor:pointer;"]);
const CloseButton = /*#__PURE__*/styled('button').withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-6"
})(["border:none;background:", ";border-radius:50%;height:16px;width:16px;display:flex;align-items:center;align-self:flex-start;justify-content:center;cursor:pointer;"], ({
  theme
}) => theme.palette.gray[800]);
const CloseIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-30051113__sc-ipxb9j-7"
})(["display:flex;color:", ";"], ({
  theme
}) => theme.palette.white);
const AttachmentPill = ({
  attachment,
  onClose
}) => {
  const {
    formatMessage
  } = useIntl();
  const thumbnailRef = useRef(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!isModalOpen);
  };
  const handleKeyDownImage = event => {
    if (event.key === keys.ENTER) {
      toggleModal();
    }
  };
  const handleKeyDownIcon = event => {
    if (event.key === keys.ENTER) {
      onClose === null || onClose === void 0 || onClose();
    }
  };
  const isImage = attachment.type.split('/').includes('image');
  const getImgUrl = useMemo(() => URL.createObjectURL(attachment), [attachment]);
  const splitFileName = attachment.name.split('.');
  const fileName = splitFileName.slice(0, splitFileName.length - 1).join('.');
  const fileExtension = splitFileName.pop();
  const {
    getDataTaktAttributes
  } = useTaktId({
    fallbackId: 'close-button'
  });
  return /*#__PURE__*/React__default.createElement(Pill, null, isImage ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Modal, {
    isOpen: isModalOpen,
    onClose: toggleModal,
    toggleEl: thumbnailRef.current,
    padding: "micro"
  }, /*#__PURE__*/React__default.createElement(LargeImage, {
    alt: attachment.name,
    src: URL.createObjectURL(attachment)
  })), /*#__PURE__*/React__default.createElement(Thumbnail, {
    "aria-haspopup": "true",
    ref: thumbnailRef,
    tabIndex: 0,
    role: "button",
    onKeyDown: handleKeyDownImage,
    onClick: toggleModal
  }, /*#__PURE__*/React__default.createElement(SmallImage, {
    alt: formatMessage({
      id: 'thumbnail-alt'
    }, {
      attachment: attachment.name
    }),
    src: getImgUrl
  }))) : /*#__PURE__*/React__default.createElement(TextWrapper, null, /*#__PURE__*/React__default.createElement(FileText, {
    type: "p"
  }, fileName), /*#__PURE__*/React__default.createElement(FileText, {
    type: "h6",
    fontSize: "tiny",
    textColor: "tertiary"
  }, fileExtension)), /*#__PURE__*/React__default.createElement(CloseButton, _extends({}, getDataTaktAttributes(), {
    tabIndex: 0,
    onClick: onClose,
    onKeyDown: handleKeyDownIcon,
    "aria-label": formatMessage({
      id: 'remove-attachment'
    }, {
      attachment: attachment.name
    })
  }), /*#__PURE__*/React__default.createElement(CloseIcon, {
    id: attachment.name,
    type: times,
    size: "xs"
  })));
};
var AttachmentPill$1 = AttachmentPill;

export { AttachmentPill$1 as A };
//# sourceMappingURL=AttachmentPill-a0631958.js.map
